import { iCalImportIdZodSchema } from "@@/shared/channels/ical/ical-import-channel";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { timeRangeZodSchema } from "@@/shared/date-time/time-range";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const newReservationCommandZodObject = z.object({
    _type: z.literal("NEW_RESERVATION"),

    externalId: z.string(), //ICal UID
    externalOrderId: z.string().optional(),
    timeRange: timeRangeZodSchema,

    description: z.string(),
});
const deleteReservationCommandZodObject = z.object({
    _type: z.literal("DELETE_RESERVATION"),
    externalId: z.string(), //ICal UID
});

const iCalCommandsZodObject = z.discriminatedUnion("_type", [
    newReservationCommandZodObject,
    deleteReservationCommandZodObject,
]);

const iCalReservationsUpdateCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("ICAL_RESERVATIONS_UPDATE_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    providerId: providerIdZodSchema,
    iCalId: iCalImportIdZodSchema,
    commands: z.array(iCalCommandsZodObject).min(1),
});
type iCalReservationsUpdateCommand = z.infer<
    typeof iCalReservationsUpdateCommandZodObject
>;

const iCalReservationsUpdateFactoryParamsZodObject =
    iCalReservationsUpdateCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof iCalReservationsUpdateFactoryParamsZodObject
>;

const iCalReservationsUpdateCommandFactory = (params: FactoryParams) => {
    const command: iCalReservationsUpdateCommand = {
        ...params,
        _id: generateId({ prefix: "ical_command__" }),
        _type: "ICAL_RESERVATIONS_UPDATE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export {
    iCalReservationsUpdateCommandFactory,
    iCalReservationsUpdateCommandZodObject,
    iCalReservationsUpdateFactoryParamsZodObject,
};
export type { iCalReservationsUpdateCommand };
